export default __webpack_public_path__ + "static/media/FittyAI_logo_text_right_2_white.b73d6e83.svg";